export const aspectRatio16to9 = {
  width: 1920,
  height: 1080,
};

export const aspectRatio3to2 = {
  width: 2400,
  height: 1600,
};

export const aspectRatio4to5 = {
  width: 1080,
  height: 1350,
};
